import PropTypes from 'prop-types';
import React from 'react';

import { Trans, useTranslation } from 'react-i18next';

import { Button, Grid, Header, Modal } from 'semantic-ui-react';

function OrderPicker({ order, selectedAttendees, onSelect = () => {} }) {
    const { t } = useTranslation();

    const isAttendeeSelected = attendee => {
        return selectedAttendees.findIndex(sattendee => sattendee.pk === attendee.pk) > -1;
    };

    return (
        <Grid.Column>
            <div key={order.id} className="attendees-order-picker">
                <div className="attendees-order-picker-order">
                    <Header as="h4" inverted>
                        {`${t('attendee.orderWord')} #${order.id}`}
                    </Header>
                    <ul>
                        {order.attendees.map(attendee => (
                            <li key={attendee.pk} className={isAttendeeSelected(attendee) ? `attendee-selected` : ''}>
                                {attendee.name} - ({`${t('attendee.barcode')}: ${attendee.barcode}`})
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="attendees-order-picker-picker">
                    <Button primary content={t('attendees.actions.pickOrder')} onClick={() => onSelect(order)} />
                </div>
            </div>
        </Grid.Column>
    );
}

OrderPicker.propTypes = {
    onSelect: PropTypes.func.isRequired,
    selectedAttendees: PropTypes.array.isRequired,
    order: PropTypes.object.isRequired
};

export default function OrderSelector({ orders, onSubmit = () => {}, onSelect = () => {}, selectedAttendees }) {
    return (
        <React.Fragment>
            <Modal.Header>
                <Trans i18nKey="attendees.actions.swapPickOrders">Please select the orders you want to fill up</Trans>
            </Modal.Header>
            <Modal.Content>
                <Grid columns={3}>
                    {orders.map((order, i) => (
                        <OrderPicker key={i} order={order} selectedAttendees={selectedAttendees} onSelect={onSelect} />
                    ))}
                </Grid>
            </Modal.Content>

            <Modal.Actions>
                <Button color="green" inverted content="Ok" icon="checkmark" onClick={onSubmit} />
            </Modal.Actions>
        </React.Fragment>
    );
}

OrderSelector.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired,
    selectedAttendees: PropTypes.array.isRequired,
    orders: PropTypes.array.isRequired
};
